import { Component } from 'react';

class Popup extends Component {
  render() {
    const { children, wrapperCallback, className } = this.props;

    return (
      <div
        className={`popup__background ${className}`}
        onClick={() => (wrapperCallback ? wrapperCallback() : null)}
      >
        <div className="popup popup--open" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    );
  }
}

export default Popup;
